module.exports = __webpack_public_path__ + "static/media/ConfidentialityAgreement.fe073919.pdf";